import { objectSpread2 as _objectSpread2 } from '../../../_virtual/_rollupPluginBabelHelpers.js';

const onMirrorCreated = Symbol('onMirrorCreated');
const onMirrorDestroy = Symbol('onMirrorDestroy');
const defaultOptions = {
  duration: 100,
  easingFunction: 'ease-in-out'
};
function resetElementOnTransitionEnd(_ref) {
  let {
    mirror,
    original,
    classes
  } = _ref;
  if (mirror && mirror.parentNode) {
    mirror.removeEventListener('transitionend', resetElementOnTransitionEnd);
    mirror.parentNode.removeChild(mirror);
  }
  original.classList.remove(classes['source:dragging']);
}
function animate(mirror, original, _ref2, _ref3, classes) {
  let {
    x,
    y
  } = _ref2;
  let {
    duration,
    easingFunction
  } = _ref3;
  original.classList.add(classes['source:dragging']);
  const {
    m41: mirrorX,
    m42: mirrorY
  } = new DOMMatrix(mirror.style.transform);
  const distanceToTravel = Math.round(Math.hypot(mirrorX - x, mirrorY - y) * 0.8);
  duration = Math.max(distanceToTravel, 80);
  requestAnimationFrame(() => {
    mirror.addEventListener('transitionend', resetElementOnTransitionEnd.bind(this, {
      mirror,
      original,
      classes
    }));
    mirror.style.transition = `transform ${duration}ms ${easingFunction}, box-shadow ${duration}ms ${easingFunction}`;
    mirror.style.transform = `translate3d(${x}px, ${y}px, 0)`;
    mirror.style.boxShadow = '0px 0px 0px rgba(0, 0, 0, 0.17)';
  });
}
class PlaceAnimation {
  constructor(draggable) {
    this.draggable = draggable;
    this.options = _objectSpread2(_objectSpread2({}, defaultOptions), this.getOptions());
    this.classes = _objectSpread2({}, this.draggable.options.classes);
    this.lastAnimationFrame = null;
    this[onMirrorDestroy] = this[onMirrorDestroy].bind(this);
    this[onMirrorCreated] = this[onMirrorCreated].bind(this);
  }
  attach() {
    this.draggable.on('mirror:created', this[onMirrorCreated]).on('mirror:destroy', this[onMirrorDestroy]);
  }
  detach() {
    this.draggable.off('mirror:created', this[onMirrorCreated]).off('mirror:destroy', this[onMirrorDestroy]);
  }
  getOptions() {
    return this.draggable.options.placeAnimation || {};
  }
  [onMirrorCreated](_ref4) {
    let {
      mirror
    } = _ref4;
    requestAnimationFrame(() => {
      mirror.style.transition = `box-shadow ${this.options.duration}ms ${this.options.easingFunction}`;
      mirror.style.boxShadow = '0px 10px 16px rgba(0, 0, 0, 0.17)';
    });
  }
  [onMirrorDestroy](event) {
    event.cancel();
    const {
      dragEvent: {
        data: {
          originalSource,
          source
        }
      },
      mirror
    } = event.data;
    const {
      x,
      y
    } = source.getBoundingClientRect();
    cancelAnimationFrame(this.lastAnimationFrame);
    this.lastAnimationFrame = requestAnimationFrame(() => {
      animate(mirror, originalSource, {
        x,
        y
      }, this.options, this.classes);
    });
  }
}

export { PlaceAnimation as default, defaultOptions };
//# sourceMappingURL=place-animation.js.map
